/* So.lab · page produit « cure » (modèle sweet-control) (scp.js) */
(function () {
  'use strict';
  if (window.__scpReady) return; window.__scpReady = true;
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var evPromise = null;
  function themeEvents() {
    if (!evPromise) evPromise = import('@theme/events').catch(function () { return null; });
    return evPromise;
  }
  function money(cents) {
    var cur = (typeof Theme !== 'undefined' && Theme.currency) || 'EUR';
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function initGallery(root) {
    var track = q('[data-scp-track]', root);
    if (!track) return;
    var thumbs = qa('[data-scp-thumb]', root), n = track.children.length;
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function goTo(i) { track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(Number(b.dataset.scpThumb)); }); });
    var prev = q('[data-scp-prev]', root), next = q('[data-scp-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = index();
        thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      });
    }, { passive: true });
  }

  /* SOLAB EDIT : après l'ajout, ouvre le panier latéral (réglage « So.lab · Ajout au panier », coché par défaut)
     ou envoie sur la page panier si le réglage est décoché. Si le module d'événements du thème ne répond pas,
     le tiroir est rafraîchi directement au lieu de basculer vers la page panier. */
  function addToCart(items, btn, err) {
    var d = q('cart-drawer'), sid = d && d.dataset.sectionId;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var form = btn.form || btn.closest('form');
    var openDrawer = !(form && form.dataset.openDrawer === 'false');
    var body = { items: items };
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    var added = null;
    var goCart = function () { window.location.href = base + 'cart'; };
    btn.classList.add('is-loading');
    if (err) err.hidden = true;
    return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().then(function (data) { if (!res.ok || data.status) throw new Error(data.description || data.message || 'Impossible d’ajouter ce produit au panier.'); return data; }); })
      .then(function (data) { added = data; return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        qa('[data-shl-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
        if (!openDrawer || !d || typeof d.open !== 'function') { goCart(); return; }
        var sectionsP = (added && added.sections && added.sections[sid])
          ? Promise.resolve(added.sections)
          : fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
        return Promise.all([sectionsP, themeEvents()]).then(function (res) {
          var sections = res[0], ev = res[1];
          if (!sections || !sections[sid]) { goCart(); return; }
          var state = { itemCount: cart.item_count, source: 'scp-buy', sections: sections };
          if (ev && ev.CartUpdatedEvent) {
            document.dispatchEvent(new ev.CartUpdatedEvent({}, state));
            d.open();
          } else if (typeof d.renderCartContents === 'function') {
            return Promise.resolve(d.renderCartContents(state)).then(function () { d.open(); });
          } else {
            goCart();
          }
        });
      })
      .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
      .then(function () { btn.classList.remove('is-loading'); });
  }

  function initBuy(root) {
    var form = q('[data-scp-form]', root), btn = q('[data-scp-add]', root);
    if (!form || !btn) return;
    var label = q('[data-scp-label]', btn), err = q('[data-scp-error]', root);
    var fmts = qa('[data-scp-fmt]', root), plans = qa('[data-scp-plan]', root);
    var sub = q('[data-scp-plan="sub"]', root), once = q('[data-scp-plan="once"]', root), sp = q('[data-scp-sp]', root);
    var freq = q('[data-scp-freq]', root), freqWrap = q('[data-scp-freq-wrap]', root), note = q('[data-scp-preview-note]', root);
    var suffix = sub ? sub.dataset.suffix || '' : '', freeMin = Number(btn.dataset.freeMin || 0);
    function currentFmt() { var c = q('[data-scp-fmt] input:checked', root); return c ? c.closest('[data-scp-fmt]') : null; }
    function currentPlan() { var c = q('[data-scp-plan] input:checked', root); return c ? c.value : 'once'; }
    function show(el, text) { if (!el) return; el.textContent = text || ''; el.hidden = !text; }
    function subsOf(el) { try { return JSON.parse((el && el.dataset.subs) || '[]'); } catch (e) { return []; } }
    function render() {
      var f = currentFmt();
      fmts.forEach(function (el) { el.classList.toggle('is-selected', el === f); });
      var price = f ? Number(f.dataset.price) : Number(btn.dataset.price);
      var compare = f ? Number(f.dataset.compare || 0) : 0;
      var subs = subsOf(f || btn), chosen = subs[0] || null;
      var sfx = f && f.dataset.suffix != null ? f.dataset.suffix : suffix;
      if (freq) {
        var key = subs.map(function (s) { return s.id; }).join(',');
        if (freq.dataset.key !== key) {
          freq.innerHTML = '';
          subs.forEach(function (s) { var o = document.createElement('option'); o.value = s.id; o.textContent = s.name; freq.appendChild(o); });
          freq.dataset.key = key;
        }
        if (subs.length > 1) chosen = subs.filter(function (s) { return String(s.id) === freq.value; })[0] || subs[0];
        if (freqWrap) freqWrap.hidden = subs.length < 2;
      }
      if (sub) {
        sub.hidden = !chosen;
        var target = chosen && wanted === 'sub' ? sub : once;
        if (target && q('input', target)) q('input', target).checked = true;
        show(q('[data-scp-sub-price]', sub), chosen ? money(chosen.price) : '');
        show(q('[data-scp-sub-compare]', sub), chosen && chosen.price < price ? money(price) : '');
        show(q('[data-scp-sub-per]', sub), sfx);
        if (note) note.hidden = !(chosen && !chosen.id);
      }
      if (once) {
        show(q('[data-scp-once-price]', once), money(price));
        show(q('[data-scp-once-compare]', once), compare > price ? money(compare) : '');
      }
      var useSub = currentPlan() === 'sub' && !!chosen;
      plans.forEach(function (el) { el.classList.toggle('is-selected', el.dataset.scpPlan === (useSub ? 'sub' : 'once')); });
      if (sp) { sp.value = useSub && chosen.id ? chosen.id : ''; sp.disabled = !sp.value; }
      var qty = q('[name="quantity"]', form);
      if (qty) qty.value = f ? f.dataset.qty || 1 : 1;
      var onceFree = freeMin > 0 && price >= freeMin;
      qa('[data-scp-shipline]', root).forEach(function (li) {
        var free = li.dataset.scpShipline === 'order' ? useSub || onceFree : onceFree;
        qa('[data-ship]', li).forEach(function (s) { s.hidden = (s.dataset.ship === 'free') !== free; });
      });
      var available = f ? f.dataset.available === 'true' : btn.dataset.available === 'true';
      btn.disabled = !available;
      if (label) label.textContent = available ? btn.dataset.label + ' – ' + money(useSub ? chosen.price : price) + (useSub && sfx ? ' ' + sfx : '') : (btn.dataset.soldout || btn.dataset.label);
    }
    var wanted = currentPlan();
    if (freq) freq.addEventListener('change', render);
    fmts.forEach(function (el) { var i = q('input', el); if (i) i.addEventListener('change', render); });
    plans.forEach(function (el) {
      var i = q('input', el);
      if (i) i.addEventListener('change', function () { wanted = i.value; render(); });
      el.addEventListener('click', function (e) {
        if (!i || i.checked || e.target.closest('a, label')) return;
        i.checked = true;
        wanted = i.value;
        render();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = currentFmt(), idInput = q('[name="id"]', form);
      var item = { id: Number(f ? f.dataset.variant : idInput && idInput.value), quantity: f ? Number(f.dataset.qty) || 1 : 1 };
      if (sp && !sp.disabled && sp.value) item.selling_plan = Number(sp.value);
      if (!item.id || btn.disabled) return;
      addToCart([item], btn, err);
    });
    render();
  }

  function initDrag(el) {
    if (el.__scpDrag) return; el.__scpDrag = true;
    var down = false, moved = false, x0 = 0, s0 = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || el.scrollWidth <= el.clientWidth) return;
      down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 4) { moved = true; el.style.scrollSnapType = 'none'; el.style.cursor = 'grabbing'; }
      if (moved) { el.scrollLeft = s0 - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; el.style.cursor = '';
      if (moved) {
        var left = el.scrollLeft; el.style.scrollSnapType = ''; el.scrollLeft = left;
        setTimeout(function () { moved = false; }, 0);
      }
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initCarousel(root) {
    var track = q('[data-scp-car-track]', root);
    if (!track || track.__scpCar) return; track.__scpCar = true;
    var prev = q('[data-scp-car-prev]', root), next = q('[data-scp-car-next]', root), nav = q('[data-scp-car-nav]', root);
    function step() {
      var c = track.firstElementChild;
      return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (nav) nav.hidden = max <= 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function closeDrawer(d) {
    if (!d.open || d.__scpClosing) return;
    d.__scpClosing = true;
    d.classList.remove('is-open');
    var wait = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320;
    setTimeout(function () { d.__scpClosing = false; if (d.open) d.close(); }, wait);
  }

  function openDrawer(d) {
    if (d.open) return;
    if (!d.__scpBound) {
      d.__scpBound = true;
      d.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(d); });
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-scp-drawer-close]')) closeDrawer(d); });
      d.addEventListener('close', function () { d.classList.remove('is-open'); document.documentElement.classList.remove('scp-locked'); });
    }
    d.showModal();
    document.documentElement.classList.add('scp-locked');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
  }

  function initDrawers(root) {
    qa('[data-scp-drawer-open]', root).forEach(function (btn) {
      if (btn.__scpDrawer) return; btn.__scpDrawer = true;
      var d = document.getElementById(btn.getAttribute('aria-controls'));
      if (!d || typeof d.showModal !== 'function') return;
      btn.addEventListener('click', function () { openDrawer(d); });
    });
  }

  function initExclusive(root) {
    qa('details[data-scp-excl]', root).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        qa('details[data-scp-excl="' + d.dataset.scpExcl + '"]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  // Avis Judge.me : « Lire la suite » sur les avis longs, pages suivantes chargées depuis Judge.me
  function initReviews(list) {
    if (list.__scpRevs) return; list.__scpRevs = true;
    var feed = list.parentNode, more = q('[data-scp-revs-more]', feed), tpl = q('template[data-scp-rev-tpl]', feed);
    var d = list.dataset, per = parseInt(d.perPage, 10) || 5, total = parseInt(d.total, 10) || 0;
    var months = (d.months || '').split(','), page = list.children.length ? 1 : 0, busy = false, ended = false;
    var seen = {};
    qa('.scp-rcard', list).forEach(function (c) { seen[c.dataset.id] = true; });

    function clamp(card) {
      var text = q('.scp-rcard__text', card);
      if (!text || text.scrollHeight <= text.clientHeight + 2) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'scp-rcard__toggle'; btn.textContent = d.open; btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? d.close : d.open; btn.setAttribute('aria-expanded', String(open));
      });
      text.after(btn);
    }
    function el(tag, cls, txt) { var e = document.createElement(tag); e.className = cls; if (txt) e.textContent = txt; return e; }
    function name(raw) {
      var w = (raw || '').trim().split(/\s+/).filter(Boolean);
      if (!w.length) return 'Anonyme';
      var n = w[0].charAt(0).toUpperCase() + w[0].slice(1);
      if (w.length > 1) { var l = w[w.length - 1]; n += ' ' + (l.indexOf('.') > -1 ? l : l.charAt(0).toUpperCase() + '.'); }
      return n;
    }
    function card(r) {
      var txt = q('.jdgm-rev__body', r), body = txt ? txt.textContent.trim() : '';
      if (!body || seen[r.dataset.reviewId]) return null;
      seen[r.dataset.reviewId] = true;
      var li = el('li', 'scp-rcard'), head = el('div', 'scp-rcard__head'), who = el('div', 'scp-rcard__who'), meta = el('p', 'scp-rcard__meta');
      var au = q('.jdgm-rev__author', r), author = name(au && au.textContent);
      li.dataset.id = r.dataset.reviewId || '';
      head.appendChild(el('span', 'scp-rcard__avatar', author.charAt(0))).setAttribute('aria-hidden', 'true');
      who.appendChild(el('p', 'scp-rcard__author', author));
      if (r.dataset.verifiedBuyer === 'true' && tpl) {
        var badge = tpl.content.querySelector('.scp-rcard__badge').cloneNode(true);
        badge.appendChild(document.createTextNode(d.verified)); meta.appendChild(badge);
      }
      var ts = q('.jdgm-rev__timestamp', r), ymd = ts ? (ts.getAttribute('data-content') || '').split(' ')[0].split('-') : [];
      if (ymd.length === 3 && months[+ymd[1] - 1]) meta.appendChild(el('span', '', (+ymd[2]) + ' ' + months[+ymd[1] - 1] + ' ' + ymd[0]));
      who.appendChild(meta); head.appendChild(who);
      var sc = q('[data-score]', r), stars = tpl && tpl.content.querySelector('[data-stars="' + Math.round(sc ? +sc.getAttribute('data-score') : 0) + '"]');
      if (stars) head.appendChild(stars.firstElementChild.cloneNode(true));
      li.appendChild(head);
      var ti = q('.jdgm-rev__title', r);
      if (ti && ti.textContent.trim()) li.appendChild(el('p', 'scp-rcard__title', ti.textContent.trim()));
      li.appendChild(el('p', 'scp-rcard__text', body));
      return li;
    }
    function finish() {
      busy = false; more.removeAttribute('aria-busy');
      more.hidden = ended || page * per >= total;
    }
    function load() {
      if (busy) return; busy = true;
      more.setAttribute('aria-busy', 'true');
      var params = new URLSearchParams({ url: d.shop, shop_domain: d.shop, platform: 'shopify', review_type: 'product-reviews', page: page + 1, per_page: per, product_id: d.product });
      fetch(d.url + '?' + params, { headers: { Accept: 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then(function (raw) {
          var html = raw;
          try { html = JSON.parse(raw).html || ''; } catch (e) { /* réponse HTML brute */ }
          var revs = qa('.jdgm-rev', new DOMParser().parseFromString(html, 'text/html'));
          if (!revs.length) { ended = true; return false; }
          page += 1;
          var added = revs.map(card).filter(Boolean);
          added.forEach(function (c) { list.appendChild(c); clamp(c); });
          // une page sans avis texte : on passe directement à la suivante
          return !added.length && page * per < total;
        })
        .catch(function () { ended = true; return false; })
        .then(function (again) { finish(); if (again) load(); });
    }
    qa('.scp-rcard', list).forEach(clamp);
    if (!more) return;
    more.addEventListener('click', load);
    if (!page && total) load(); else finish();
  }

  function init(scope) {
    scope = scope || document;
    qa('[data-scp-gal]', scope).forEach(initGallery);
    qa('[data-scp-main]', scope).forEach(initBuy);
    qa('[data-scp-drag]', scope).forEach(initDrag);
    qa('[data-scp-car]', scope).forEach(initCarousel);
    qa('[data-scp-revs]', scope).forEach(initReviews);
    initDrawers(scope);
    initExclusive(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { document.documentElement.classList.remove('scp-locked'); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.scp-acard');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
  });
})();
